module.exports = __webpack_public_path__ + "media/soundtrack.b41a5f8c.mp3";